import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from '@/hooks/use-toast';
import { useQueryClient } from '@tanstack/react-query';
import { SettingsBreadcrumb } from '@/components/SettingsBreadcrumb';
import { useCreateProduct } from '@/hooksApi/useProductCatalog';
import ProductForm from './ProductForm';
import type { ProductCatalogRequest } from '@/types/productCatalog';

const SettingsProductCatalogNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: createProduct, isLoading: isCreating } = useCreateProduct();

  const handleSave = (data: ProductCatalogRequest) => {
    createProduct(data, {
      onSuccess: () => {
        toast({
          title: String(t('success_title', { defaultValue: 'Success' })),
          description: String(t('product_added', { defaultValue: 'Product added successfully.' })),
        });
        queryClient.invalidateQueries(['product-catalog']);
        navigate('/settings/product-catalog');
      },
      onError: (error: any) => {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          String(t('operation_failed', { defaultValue: 'Operation failed. Please try again.' }));
        toast({
          title: String(t('error_title', { defaultValue: 'Error' })),
          description: msg,
          variant: 'destructive',
        });
      },
    });
  };

  return (
    <div className='sd-scope sd-font flex flex-col'>
      <div className='p-6 pb-0 max-w-3xl w-full mx-auto'>
        <SettingsBreadcrumb
          moduleName='product_catalog'
          moduleRoute='/settings/product-catalog'
          action='add_product'
        />
      </div>
      <ProductForm
        onSave={handleSave}
        onCancel={() => navigate('/settings/product-catalog')}
        isLoading={isCreating}
      />
    </div>
  );
};

export default SettingsProductCatalogNew;
